<template>
  <div class="ft ft_gl">
    <ul class="u2 u_fgl uf">
      <!-- <li v-if="flag > 2 && flag < 7" :class="{ liw: flag > 5 }">
        <router-link :to="zfUrl"
          ><p :class="{ on: path == '/' || path == zfUrl }">
            <i class="iC2 i_xq"></i> <span>详情</span>
          </p></router-link
        >
      </li> -->
      <li v-if="flag > 2" :class="{ liw: flag > 5 }">
        <router-link to="/info/xtj"
          ><p :class="{ on: path == '/info/xtj' }">
            <i class="iC2 i_xtj"></i> <span>新统计</span>
          </p></router-link
        >
      </li>
      <li v-if="flag > 2" :class="{ liw: flag > 5 }">
        <router-link to="/info/ytj"
          ><p :class="{ on: path == '/info/ytj' }">
            <i class="iC2 i_ytj"></i> <span>已完成</span>
          </p></router-link
        >
      </li>
      <li v-if="flag > 2" :class="{ liw: flag > 5 }">
        <router-link to="/info/wtg"
          ><p :class="{ on: path == '/info/wtg' }">
            <i class="iC2 i_wtg"></i> <span>已提交</span>
          </p></router-link
        >
      </li>

      <!-- <li v-if="flag > 2" :class="{ liw: flag > 5 }">
        <router-link to="/"
          ><p :class="{ on: path == '/' || path == '/info/list' }">
            <i class="iC2 i_xxtb"></i> <span>信息填报</span>
          </p></router-link
        >
      </li> -->

      <!-- :class="{ liw: flag>2 }" -->
      <li v-if="flag < 6" :class="{ liw: flag < 3 }">
        <router-link to="/organization/management"
          ><p :class="{ on: path == '/organization/management' }">
            <i class="iC2 i_zzgl"></i> <span>组织管理</span>
          </p></router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from "vue";
import { getRoleId } from "@/common/js";
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const state = reactive({
      flag: false,
      path: route.path,
      zfUrl: "",
    });

    onMounted(async () => {
      const f = await getRoleId();
      state.flag = f;
      if (f == 6) {
        state.zfUrl = "/info/detail/counsellor";
      }
      if (f == 5 || f == 4 || f == 3) {
        state.zfUrl = "/info/detail/zf";
      }
    });

    return {
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/mixin";
.liw {
  // width: 100%;
  width: 50%;
}
.uf {
  width: auto;
  display: flex;
  justify-content: space-around;
}
.nav-bar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 5px 0;
  z-index: 1000;
  background: #fff;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  .nav-list {
    width: 100%;
    .fj();
    flex-direction: row;
    padding: 0;
    .nav-list-item {
      display: flex;
      flex: 1;
      flex-direction: column;
      text-align: center;
      color: #666;
      &.router-link-active {
        color: @primary;
      }
      i {
        text-align: center;
        font-size: 22px;
      }
      span {
        font-size: 12px;
      }
    }
  }
}
.u_fgl p {
  color: #666;
}
</style>
